<div class="mainDivThumbnail" #container [ngClass]="mainDivClass" (click)="onClick()">

  <div [ngClass]="{'thumbnail-image' : !profileImage, 'thumbnail-circle': profileImage}" *ngIf="propertyData && loaded"
    [style.backgroundImage]="'url(' + (this.propertyData)  + ')' | safe: 'style'" data-cy="thumbnail-photo-photo">
  </div>

  <!-- <div [ngClass]="{'thumbnail-image' : !profileImage, 'thumbnail-circle': profileImage}" *ngIf="propertyData && loaded"
    data-cy="thumbnail-photo-photo">
    <ion-img *ngIf="propertyData" [src]="propertyData"></ion-img>
  </div> -->

  <div class="suggestion-tile" *ngIf="isSuggestion && !saving">
    <div class="loading" *ngIf="isLoading && !isLoaded">
    </div>
    <div class="select" *ngIf="isLoaded" (click)="setSuggestion(this.propertyData, index, $event)">
      <ion-icon name="checkmark-outline"></ion-icon>
    </div>
    <div class="body" *ngIf="isLoaded">
      <ion-label class="item-value"> Confirm? </ion-label>
    </div>
    <div class="cancel" *ngIf="isLoading || isLoaded" (click)="cancelSuggestion(this.propertyData, index, $event)">
      <ion-icon name="close-outline"></ion-icon>
    </div>
  </div>

  <div class="unableToLoadImage" *ngIf="!propertyData && loaded" data-cy="thumbnail-photo-photo-fail">
  </div>

  <div class="thumbnail-overflow" *ngIf="!loaded || saving">
    <ion-spinner name="crescent"></ion-spinner>
  </div>

  <div class="thumbnail-overflow" *ngIf="loaded && !isSuggestion">
    <div class="thumbnail-trash" (click)="onDelete($event)" *ngIf="property" data-cy="thumbnail-photo-delIcon">
      <ion-icon name="trash"></ion-icon>
    </div>
    <div class="exist-label disable-selection" *ngIf="propertyData">
      {{existLabel}}
    </div>

    <div class="thumbnail-label disable-selection" *ngIf="!propertyData">{{label}}</div>
  </div>
</div>